import { createContext } from 'react';

const YoutrackIssuesContext = createContext({ services: [] });

export default YoutrackIssuesContext;
